/* global Cookies, attachEvent */

// *******************************************************************************
// Close Info Bar
// *******************************************************************************

const infoBar = document.querySelector('.info-bar');

const hideInfoBar = () => {
  infoBar.classList.add('d-none');
  document.body.style.setProperty('--top-bar-height', '0px');
};

attachEvent('.info-bar__close', 'click', () => {
  hideInfoBar();
  Cookies.set('info-bar-seen', 'true');
});
